import React from 'react';
import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';
import WidthContainer from '../../../WidthContainer';
import {
  BodyLarge,
  Heading1Text,
  TitleLarge,
  TitleMedium,
} from '../../../Texts';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 200px;
  padding-bottom: 200px;
  gap: 30px;
`;

const BackgroundColor = styled.div`
  background-color: ${({ theme }) => theme.background.light};
`;

const StyledTitleLarge = styled(TitleLarge)`
  font-weight: 600;
`;

const RowContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 30px;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
  }
`;

const Item = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.background.secondary};
  height: 200px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 20px;
`;

const HowToStart = () => {
  return (
    <BackgroundColor>
      <WidthContainer>
        <Container>
          <Heading1Text>How to Start?</Heading1Text>
          <RowContainer>
            <Item>
              <StyledTitleLarge>Application form</StyledTitleLarge>
              <BodyLarge>
                Fill out the short application form: deks.xyz/referral-apply
              </BodyLarge>
            </Item>
            <Item>
              <StyledTitleLarge>Referral link</StyledTitleLarge>
              <BodyLarge>
                Receive your personal referral link and media kit.
              </BodyLarge>
            </Item>
            <Item>
              <StyledTitleLarge>Share your project</StyledTitleLarge>
              <BodyLarge>Introduce DEKS to projects in your network.</BodyLarge>
            </Item>
            <Item>
              <StyledTitleLarge>Earn USDC</StyledTitleLarge>
              <BodyLarge>
                Earn USDC every month, paid automatically to your wallet.
              </BodyLarge>
            </Item>
          </RowContainer>
        </Container>
      </WidthContainer>
    </BackgroundColor>
  );
};

export default HowToStart;
